import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-application-cog-outline',
  templateUrl: './icon-application-cog-outline.component.html',
  styleUrl: './icon-application-cog-outline.component.scss',
  standalone: false,
})
export class IconApplicationCogOutlineComponent {
  @Input() tooltip?: string;
}
